import { useLocation } from "react-router-dom"
import { redirectToSso } from "@alascorporation/api-client"
import { ssoConfig } from "../../../lib/sso"

type PurchaseCardProps = {
  price?: number | null
  showBuyButton: boolean
  isAuthenticated: boolean
  buyLoading: boolean
  buyError: string | null
  onBuy: () => void
}

export default function PurchaseCard({ price, showBuyButton, isAuthenticated, buyLoading, buyError, onBuy }: PurchaseCardProps) {
  const location = useLocation()
  if (!showBuyButton) return null
  return (
    <div className="rounded-xl border border-primary/30 bg-primary/[0.05] p-6">
          <p className="text-micro font-bold uppercase tracking-widest text-primary mb-1">Acceso completo</p>
          {price ? (
            <p className="text-3xl font-extrabold text-foreground mb-5">
              ${Number(price).toLocaleString('es-CO')} <span className="text-base font-normal text-muted-foreground">COP</span>
            </p>
          ) : null}
          <button
            onClick={onBuy}
            disabled={buyLoading}
            aria-busy={buyLoading}
            className="w-full rounded-lg bg-primary py-3 text-sm font-bold text-primary-foreground outline-none transition-[filter,transform,opacity] hover:brightness-110 active:scale-95 disabled:opacity-60 disabled:hover:brightness-100 focus-visible:ring-3 focus-visible:ring-ring/50"
          >
            {buyLoading ? 'Procesando...' : 'Comprar ahora'}
          </button>
          {buyError && (
            <p role="alert" className="mt-3 text-center text-xs text-destructive">{buyError}</p>
          )}
          {!isAuthenticated && (
            <p className="mt-3 text-center text-xs text-muted-foreground">
              <button
                type="button"
                onClick={() => redirectToSso(ssoConfig, location.pathname)}
                className="rounded text-primary outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring"
              >
                Inicia sesión
              </button> para comprar
            </p>
          )}
    </div>
  )
}
